import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { Container, Grid, Header, Icon, Image, Input, Segment, Divider } from 'semantic-ui-react';
import { Footer, Button } from 'components';

import styles from './LicensePrice.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class LicensePrice extends Component {
  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    return (
      <div className={cx('licensePrice-wrapper')}>
        <div className={cx('licensePrice-wrapper-inner')}>
          <Segment vertical>
            <Container className={cx('licensePrice-title')} text>
              <Header
                as="h1"
                content={defineMessages(formatMessage({ id: 'LicensePrice_1', defaultMessage: 'MudFix 라이센스' }))}
              />
            </Container>

            <Divider />

            {/* 가격 bar 영역 */}
            <div className={cx('bar-area')}>
              {/* <div className={cx('bar-background')} /> */}
              <div className={cx('bar')}>
                <div className={cx('bar-title')}>Starter</div>
                <div className={cx('content')}>
                  <div className={cx('price')}>
                    <span className={cx('number')}>
                      {defineMessages(formatMessage({ id: 'LicensePrice_2', defaultMessage: '무료' }))}
                    </span>
                    <span className={cx('unit')} />
                  </div>
                  <div className={cx('target')}>
                    <span className={cx('number')}>1 ~ 5</span>
                    <span className={cx('unit')}>Users</span>
                  </div>
                </div>
              </div>
              <div className={cx('bar')}>
                <div className={cx('bar-title')}>Experience</div>
                <div className={cx('content')}>
                  <div className={cx('price')}>
                    <span className={cx('number')}>50</span>
                    <span className={cx('unit')}>
                      {defineMessages(formatMessage({ id: 'LicensePrice_3', defaultMessage: '만원' }))}
                    </span>
                  </div>
                  <div className={cx('target')}>
                    <span className={cx('number')}>6 ~ 10</span>
                    <span className={cx('unit')}>Users</span>
                  </div>
                  <div className={cx('target')}>
                    <span className={cx('number')}>1</span>
                    <span className={cx('unit')}>Years</span>
                  </div>
                </div>
              </div>
              <div className={cx('bar')}>
                <div className={cx('bar-title')}>Basic</div>
                <div className={cx('content')}>
                  <div className={cx('price')}>
                    <span className={cx('number')}>300</span>
                    <span className={cx('unit')}>
                      {defineMessages(formatMessage({ id: 'LicensePrice_3', defaultMessage: '만원' }))}
                    </span>
                  </div>
                  <div className={cx('target')}>
                    <span className={cx('number')}>11 ~ 100</span>
                    <span className={cx('unit')}>Users</span>
                  </div>
                  <div className={cx('target')}>
                    <span className={cx('number')}>1</span>
                    <span className={cx('unit')}>Years</span>
                  </div>
                </div>
              </div>
              <div className={cx('bar')}>
                <div className={cx('bar-title')}>Standard</div>
                <div className={cx('content')}>
                  <div className={cx('price')}>
                    <span className={cx('number')}>500</span>
                    <span className={cx('unit')}>
                      {defineMessages(formatMessage({ id: 'LicensePrice_3', defaultMessage: '만원' }))}
                    </span>
                  </div>
                  <div className={cx('target')}>
                    <span className={cx('number')}>101 ~ 300</span>
                    <span className={cx('unit')}>Users</span>
                  </div>
                  <div className={cx('target')}>
                    <span className={cx('number')}>1</span>
                    <span className={cx('unit')}>Years</span>
                  </div>
                </div>
              </div>
              <div className={cx('bar')}>
                <div className={cx('bar-title')}>Advanced</div>
                <div className={cx('content')}>
                  <div className={cx('price')}>
                    <span className={cx('number')}>700</span>
                    <span className={cx('unit')}>
                      {defineMessages(formatMessage({ id: 'LicensePrice_3', defaultMessage: '만원' }))}
                    </span>
                  </div>
                  <div className={cx('target')}>
                    <span className={cx('number')}>301 ~ 500</span>
                    <span className={cx('unit')}>Users</span>
                  </div>
                  <div className={cx('target')}>
                    <span className={cx('number')}>1</span>
                    <span className={cx('unit')}>Years</span>
                  </div>
                </div>
              </div>
              <div className={cx('bar')}>
                <div className={cx('bar-title')}>Pro</div>
                <div className={cx('content')}>
                  <div className={cx('price')}>
                    <span className={cx('number')}>900</span>
                    <span className={cx('unit')}>
                      {defineMessages(formatMessage({ id: 'LicensePrice_3', defaultMessage: '만원' }))}
                    </span>
                  </div>
                  <div className={cx('target')}>
                    <span className={cx('number')}>501 ~ 700</span>
                    <span className={cx('unit')}>Users</span>
                  </div>
                  <div className={cx('target')}>
                    <span className={cx('number')}>1</span>
                    <span className={cx('unit')}>Years</span>
                  </div>
                </div>
              </div>
              <div className={cx('bar')}>
                <div className={cx('bar-title')}>Premium</div>
                <div className={cx('content')}>
                  <div className={cx('price')}>
                    <span className={cx('number')}>1200</span>
                    <span className={cx('unit')}>
                      {defineMessages(formatMessage({ id: 'LicensePrice_3', defaultMessage: '만원' }))}
                    </span>
                  </div>
                  <div className={cx('target')}>
                    <span className={cx('number')}>701 ~ 1000</span>
                    <span className={cx('unit')}>Users</span>
                  </div>
                  <div className={cx('target')}>
                    <span className={cx('number')}>1</span>
                    <span className={cx('unit')}>Years</span>
                  </div>
                </div>
              </div>
              <div className={cx('bar')}>
                <div className={cx('bar-title')}>Enterprise</div>
                <div className={cx('content')}>
                  <div className={cx('price')}>
                    <span className={cx('number font-size-32')}>
                      {defineMessages(formatMessage({ id: 'LicensePrice_4', defaultMessage: '문의하기' }))}
                    </span>
                    <span className={cx('unit')} />
                  </div>
                  <div className={cx('target')}>
                    <span className={cx('number')}>1001 ~</span>
                    <span className={cx('unit')}>Users</span>
                  </div>
                </div>
              </div>
            </div>

            {/* 부가 설명 */}
            <div className={cx('license-note')}>
              <div className={cx('title bold')}>
                <Icon name="info circle" />Infomation
              </div>
              <div className={cx('content')}>
                <div className={cx('bold')}>
                  {defineMessages(
                    formatMessage({
                      id: 'LicensePrice_9',
                      defaultMessage: '- 상기 비용은 기술지원료가 포함되지 않은 순수 서비스 이용 금액입니다.'
                    })
                  )}
                </div>
                <div className={cx('bold')}>
                  {defineMessages(
                    formatMessage({
                      id: 'LicensePrice_10',
                      defaultMessage: '- 상기 비용은 국내 이용에 한해 적용되며, 해외 법인 등은 별도로 문의해주세요'
                    })
                  )}
                </div>
                <div>
                  {defineMessages(
                    formatMessage({
                      id: 'LicensePrice_5',
                      defaultMessage:
                        '- 라이센스는 대상자 이메일의 도메인 단위로 필요합니다. (1개의 라이센스는 1개의 이메일 도메인만 지원)'
                    })
                  )}
                </div>
                <div>
                  {defineMessages(
                    formatMessage({
                      id: 'LicensePrice_6',
                      defaultMessage: '- 라이센스 사용 기간은 1년 단위로만 구매 가능합니다'
                    })
                  )}
                </div>
                <div>
                  {defineMessages(
                    formatMessage({
                      id: 'LicensePrice_7',
                      defaultMessage: '- 라이센스 구매는 로그인 후 [마이페이지] > [라이센스] 메뉴를 통해 진행합니다.'
                    })
                  )}
                </div>
                <div>
                  {defineMessages(
                    formatMessage({
                      id: 'LicensePrice_8',
                      defaultMessage: '- 대규모 및 Stand-alone(독립형) 구축 서비스는 문의해주세요.'
                    })
                  )}
                </div>
              </div>
            </div>
          </Segment>
          <Footer />
        </div>
      </div>
    );
  }
}

LicensePrice.propTypes = {};
LicensePrice.defaultProps = {};

export default injectIntl(LicensePrice);

/* 가격 bar 영역 */
/* <div className={cx('bar-area')}>
    <div className={cx('bar-background')} />
    <div className={cx('bar')}>
      <div className={cx('bar-title')}>Basic</div>
      <div className={cx('content')}>
        <div className={cx('price')}>
          <span className={cx('number')}>79</span>
          <span className={cx('unit')}>{defineMessages(formatMessage({ id: 'LicensePrice_3', defaultMessage: '만원' }))}</span>
        </div>
        <div className={cx('target')}>
          <span className={cx('number')}>100</span>
          <span className={cx('unit')}>Users</span>
        </div>
        <div className={cx('period')}>
          <span className={cx('number')}>1</span>
          <span className={cx('unit')}>Years</span>
        </div>
      </div>
    </div>
    <div className={cx('bar')}>
      <div className={cx('bar-title')}>Standard</div>
      <div className={cx('content')}>
        <div className={cx('price')}>
          <span className={cx('number')}>699</span>
          <span className={cx('unit')}>{defineMessages(formatMessage({ id: 'LicensePrice_3', defaultMessage: '만원' }))}</span>
        </div>
        <div className={cx('target')}>
          <span className={cx('number')}>1000</span>
          <span className={cx('unit')}>Users</span>
        </div>
        <div className={cx('period')}>
          <span className={cx('number')}>1</span>
          <span className={cx('unit')}>Years</span>
        </div>
      </div>
    </div>
    <div className={cx('bar')}>
      <div className={cx('bar-title')}>Enterprise</div>
      <div className={cx('content')}>
        <div className={cx('price')}>
          <span className={cx('number')}>999</span>
          <span className={cx('unit')}>{defineMessages(formatMessage({ id: 'LicensePrice_3', defaultMessage: '만원' }))}</span>
        </div>
        <div className={cx('target')}>
          <span className={cx('number')}>10000</span>
          <span className={cx('unit')}>Users</span>
        </div>
        <div className={cx('period')}>
          <span className={cx('number')}>1</span>
          <span className={cx('unit')}>Years</span>
        </div>
      </div>
    </div>
  </div> */



// WEBPACK FOOTER //
// ./src/script/components/intro/LicensePrice.js